import { entityTextsForLanguages } from 'pages/job-roles/jobRoleFormMapping';
import { ClassifierData } from 'types/classifiers';
import { CustomFieldDto } from 'types/customFields';
import { JobPositionCreateOrUpdateDto, JobPositionDto, JobPositionForm } from 'types/jobPositions';
import { getOptionsFromClassifier } from 'utils/formUtil';

/** The edit form's values for a stored job position; the form adds the custom fields' values itself. */
export const jobPositionDtoToForm = (
    jobPosition: JobPositionDto,
    classifiers: Record<string, ClassifierData>
): JobPositionForm => ({
    name: jobPosition.name ?? '',
    externalId: jobPosition.externalId ?? null,
    positionTypeCode:
        (
            getOptionsFromClassifier(classifiers['JOB_POSITION_TYPE']) as {
                label: string;
                value: string;
            }[]
        ).find((val) => val.value === jobPosition.positionTypeCode) ?? null,
    entityTexts: entityTextsForLanguages(classifiers, jobPosition.entityTexts),
});

export const jobPositionFormToRequest = (
    form: JobPositionForm,
    customFields: CustomFieldDto[] = []
): JobPositionCreateOrUpdateDto => ({
    name: form.name,
    externalId: form.externalId ? form.externalId : null,
    positionTypeCode: form.positionTypeCode ? form.positionTypeCode.value : null,
    entityTexts: form.entityTexts?.filter((el) => !!el.value || (!!el.textMale && !!el.textFemale)) ?? null,
    ...(customFields.length > 0 ? { customFields } : {}),
});

/**
 * The form fields each card of the job position page edits. The external id is in none: the server takes it on
 * create only, so a card save sends it as stored.
 */
export const JOB_POSITION_SECTION_FIELDS = {
    'job-position': ['name', 'positionTypeCode'],
    translations: ['entityTexts'],
    'custom-fields': [],
} satisfies Record<string, (keyof JobPositionForm)[]>;

export type JobPositionSectionId = keyof typeof JOB_POSITION_SECTION_FIELDS;
